module.exports = __webpack_public_path__ + "static/media/CloseMenu_HBT.23fe4d7b.svg";